import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Fade,
  InputAdornment,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "../../styles/layout/header.module.scss";
import stylesQcHeader from "../../styles/layout/qcHeader.module.scss";
import logo from "../../public/assets/images/main_logo.png";
import HeaderSearchIcon from "../../ui/Icons/HeaderSearchIcon";
import HeaderMessageIcon from "../../ui/Icons/HeaderMessageIcon";
import HeaderNotificationIcon from "../../ui/Icons/HeaderNotificationIcon";
import noUser from "../../public/assets/images/profile_img.svg";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import NOprofileImage from "../../public/assets/images/no-image.svg";
import {
  setCheck,
  updateQuery,
} from "../../redux-toolkit/slices/searchQuery.slice";
import { getAbsoluteImageURI } from "../../lib/functions/utils.lib";

const QcDashboardheader = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [searchState, setSearchState] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [inSearchPage, setInSearchpage] = useState(true);
  const { query, check } = useAppSelector((s) => s.searchQuerySlice);
  const { userData: QcData } = useAppSelector((s) => s.userSlice);
  // console.warn("QcData", QcData);
  const handleSearch = () => {
    navigate("/qcagent-searchresult");
    dispatch(updateQuery(query));
    if (query) {
      dispatch(setCheck(true));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  const handleClear = () => {
    navigate("/qcagent-dashboard");
    dispatch(updateQuery(""));
    if (query) {
      dispatch(setCheck(false));
    }
  };
  React.useEffect(() => {
    if (location.pathname !== "/qcagent-searchresult") {
      dispatch(updateQuery(""));
      dispatch(setCheck(false));
    }
  }, [dispatch, location.pathname]);

  React.useEffect(() => {
    if (location.pathname === "/qcagent-searchresult") {
      setInSearchpage(false);
      if (query?.length > 1) {
        dispatch(setCheck(true));
      }
    }
  }, [dispatch, location.pathname]);

  const handleFade = () => {
    setSearchState(false);
    setBackdropOpen(!backdropOpen);
    if (location.pathname !== "/qcagent-searchresult") {
      dispatch(updateQuery(""));
    }
  };

  return (
    <AppBar
      component={"nav"}
      position="static"
      elevation={0}
      className={`${styles.headerAppbar} ${stylesQcHeader.headerAppbarQc}`}
    >
      <Toolbar>
        <Stack
          direction={"row"}
          alignItems={"center"}
          flexWrap={"wrap"}
          className={styles.mainHeader}
        >
          <Box className={styles.headerLeft}>
            <Link to="/">
              <img src={logo} alt="" width={133} height={29} />
            </Link>
          </Box>
          <Box className={styles.headerRight}>
            <form action="" onSubmit={handleSubmit}>
              <Box
                onSubmit={handleSubmit}
                className={`${styles.search_box} ${
                  searchState ? `${styles.openSearchBox}` : ""
                }`}
                // onClick={() => setSearchState(!searchState)}
              >
                <TextField
                  label=""
                  id="outlined-size-normal"
                  placeholder="Enter an email address, submitter name, VSID to search..."
                  onClick={() => {
                    setBackdropOpen(true);
                    setSearchState(true);
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment
                        position="start"
                        className={searchValue ? styles.startAdmnt : undefined}
                      >
                        <HeaderSearchIcon />
                      </InputAdornment>
                    ),

                    endAdornment:
                      backdropOpen && inSearchPage ? (
                        <InputAdornment position="end">
                          {!check ? (
                            <Button
                              onClick={handleSearch}
                              disabled={
                                query?.length === 0 ||
                                query?.length === undefined
                              }
                            >
                              Search
                            </Button>
                          ) : (
                            <Button
                              onClick={handleClear}
                              className={styles.clearBtn}
                            >
                              clear
                            </Button>
                          )}
                        </InputAdornment>
                      ) : location.pathname === "/qcagent-searchresult" &&
                        query?.length > 0 ? (
                        <Button
                          onClick={handleClear}
                          className={styles.clearBtn}
                        >
                          clear
                        </Button>
                      ) : null,
                  }}
                  value={query}
                  onChange={(e) => dispatch(updateQuery(e.target.value))}
                  sx={
                    query
                      ? {
                          border: "1px solid #111AE9",
                          borderRadius: "6px",
                        }
                      : undefined
                  }
                />
                <Fade
                  in={backdropOpen}
                  unmountOnExit
                  mountOnEnter
                  timeout={{ enter: 500, exit: 800, appear: 400 }}
                >
                  <Box
                    className={styles.srchBackdrop}
                    onClick={handleFade}
                  ></Box>
                </Fade>
              </Box>
            </form>
            <Box className={styles.headerprofileSec}>
              <ButtonGroup>
                <Button>
                  <HeaderMessageIcon />
                  <span></span>
                </Button>
                <Button>
                  <HeaderNotificationIcon />
                  <span></span>
                </Button>
              </ButtonGroup>
              <Box className={styles.profile_box}>
                <Typography variant="body1">
                  {QcData?.name}
                  {QcData?.last_name}
                  <span>QC Agent</span>
                </Typography>
                {/* <img src={noUser} alt="" width={31} height={31} /> */}
                {QcData?.avatar === "users/default.png" ? (
                  <img
                    alt="Viral Snare"
                    src={NOprofileImage}
                    width={31}
                    height={31}
                  />
                ) : (
                  <img
                    alt="sadrofile Image"
                    src={getAbsoluteImageURI(QcData?.avatar)}
                    width={31}
                    height={31}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default QcDashboardheader;
